import { render, staticRenderFns } from "./headerItem.vue?vue&type=template&id=21fe59de"
import script from "./headerItem.vue?vue&type=script&lang=js"
export * from "./headerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports